import {
  retrieveTransferChoices,
  retrieveTransferRequestChoices,
  retrieveAccountTransferChoices,
} from 'api';
import { getErrorMessage } from 'common/utils/requestErrorHandling';

/**
 * Retrieves transfer choices
 */
export const doGetTransferChoices = () => async (dispatch) => {
  dispatch({ type: 'transfer/choices/started' });

  try {
    const choices = await retrieveTransferChoices();

    dispatch({
      type: 'transfer/choices/finished',
      choices: choices,
    });
  } catch (e) {
    dispatch({
      type: 'transfer/choices/finished',
      error: getErrorMessage(e.response),
    });
  }
};

/**
 * Retrieves transfer request choices
 */
export const doGetTransferRequestChoices = () => async (dispatch) => {
  dispatch({ type: 'transfer_request/choices/started' });

  try {
    const choices = await retrieveTransferRequestChoices();

    dispatch({
      type: 'transfer_request/choices/finished',
      choices: choices,
    });
  } catch (e) {
    dispatch({
      type: 'transfer_request/choices/finished',
      error: getErrorMessage(e.response),
    });
  }
};

/**
 * Retrieves transfer choices
 */
export const doGetAccountTransferChoices = () => async (dispatch) => {
  dispatch({ type: 'account_transfer/choices/started' });

  try {
    const choices = await retrieveAccountTransferChoices();

    dispatch({
      type: 'account_transfer/choices/finished',
      choices: choices,
    });
  } catch (e) {
    dispatch({
      type: 'account_transfer/choices/finished',
      error: getErrorMessage(e.response),
    });
  }
};
